import React, { useState,useEffect } from "react";
import { isAndroid, isIOS } from "react-device-detect";
import { useSearchParams } from "react-router-dom";
import './Theme/UniversalLink.css';

function TruexDeeplink() {
    const [searchParams, setSearchParams] = useSearchParams(window.location.hash);
    const param = searchParams.get('page');
    //const [storeUrl, setStoreUrl] = useState('https://play.google.com/store/apps/details?id=com.truedigitaltdg.smartlivingtechint');
    if (param) {
        localStorage.setItem('page',param)
    }
    const handleOpenAppOrStore = () => {
        if (isAndroid) {
            window.location.href = `https://play.google.com/store/apps/details?id=com.truedigitaltdg.smartlivingtechint`;
        } else if (isIOS) {
            window.location.href = `https://apps.apple.com/th/app/truex-formerly-livingtech/id1590630747`;
        } else {
            window.location.href = `https://play.google.com/store/apps/details?id=com.truedigitaltdg.smartlivingtechint`;
        }

    }
    const handleOpenApp = () => {
        let appUrl = `livingtechint://`;
        if (param) {
            appUrl = `livingtechint://${param}`;
        }
        window.location.href = appUrl;
    }
    useEffect(async () => {
        let appUrl = `livingtechint://`;
        if (param) {
            appUrl = `livingtechint://${param}`;
        }
        window.location.href = appUrl;
    }, []);
                
    return (
        <div className="universal-link-container">
            <img src="/icon/TrueX Color Logo.png" alt="Top Image" className="top-image" />
            <section className="logo-section">
                <img src="/icon/TrueX Icon.png" alt="App Logo" onClick={handleOpenApp} />
                <p className="logo-label">Open TrueX</p>
            </section>
            <section className="message-section">
                <p>If the app does not open, download it from the store below.</p>
            </section>
            <section className="store-section">
                <img 
                src={isIOS ? "/icon/AppStore.png" : "/icon/googleplay.png"} 
                alt={isIOS ? "App Store" : "Play Store"} 
                onClick={handleOpenAppOrStore} 
                />
            </section>
        </div>
    );
}

export default TruexDeeplink;
